/* MBG AJAX cart — drawer + full cart page share this one controller.
   Vanilla JS, no dependencies. Uses Shopify's own Ajax Cart API with the
   `sections` parameter so all cart HTML is real server-rendered Liquid
   (full access to product tags/metafields for pre-order messaging) —
   never hand-built from raw JSON client-side. */
(function () {
  'use strict';

  var drawer = document.getElementById('CartDrawer');
  var sectionId = drawer ? drawer.dataset.sectionId : null;
  var requestInFlight = false;
  var quantityDebounce = null;

  function setBusy(isBusy) {
    requestInFlight = isBusy;
    document.querySelectorAll(
      '[data-mbg-qty-increase], [data-mbg-qty-decrease], [data-mbg-remove-line]'
    ).forEach(function (el) {
      el.disabled = isBusy;
    });
  }

  function updateCartCount(root) {
    var counter = root.querySelector('[data-mbg-cart-count]');
    var badge = document.getElementById('CartCount');
    if (!counter || !badge) return;
    var count = counter.textContent.trim();
    badge.querySelector('span') && (badge.querySelector('span').textContent = count);
    badge.style.display = count === '0' ? 'none' : '';
  }

  function renderDrawer(sections) {
    if (!drawer || !sectionId || !sections || !sections[sectionId]) return;
    var doc = new DOMParser().parseFromString(sections[sectionId], 'text/html');
    var fresh = doc.getElementById('CartDrawer');
    if (!fresh) return;
    drawer.innerHTML = fresh.innerHTML;
    updateCartCount(drawer);
  }

  function refreshCartPage() {
    var pageItems = document.querySelector('.mbg-cart-page');
    if (!pageItems) return;
    fetch(window.location.pathname, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.mbg-cart-page');
        if (fresh) pageItems.outerHTML = fresh.outerHTML;
      })
      .catch(function () {});
  }

  function openCartDrawer() {
    if (window.theme && theme.CartDrawer) {
      theme.CartDrawer.open();
    }
  }

  function requestSections() {
    return sectionId ? '&sections=' + encodeURIComponent(sectionId) : '';
  }

  /* Add to cart — intercept any .product-form on the page. */
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form.classList || !form.classList.contains('product-form')) return;
    if (!sectionId) return; // no drawer on this theme instance yet, let the normal form submission happen

    evt.preventDefault();
    if (requestInFlight) return;
    setBusy(true);

    var submitBtn = form.querySelector('.product-form__cart-submit');
    if (submitBtn) submitBtn.classList.add('is-loading');

    var formData = new FormData(form);
    /* Root cause of "drawer opens empty, count only updates after
       Continue Shopping": GET /cart.js does NOT support a `sections`
       query param the way the POST cart-mutation endpoints do — it just
       silently ignores it and returns plain cart JSON with no `sections`
       key at all. renderDrawer() below was correctly guarding against a
       missing sections object (so it never crashed), but that guard also
       meant it silently did nothing — leaving the drawer's stale,
       pre-add HTML in place — while openCartDrawer() opened it anyway.
       The item really was added (that part always worked); only the
       drawer's own re-render was silently failing. Fix: request the
       fresh section HTML directly from /cart/add.js itself, which DOES
       support `sections` correctly (confirmed directly against the live
       Ajax Cart API) — this also removes an entire extra round trip. */
    formData.append('sections', sectionId);

    fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          showAddError(form, result.data);
          return;
        }
        renderDrawer(result.data.sections);
        openCartDrawer();
      })
      .catch(function () {
        showAddError(form, null);
      })
      .then(function () {
        if (submitBtn) submitBtn.classList.remove('is-loading');
        setBusy(false);
      });
  });

  /* Never opens the drawer on a failed add — an empty/stale drawer after
     a genuine failure is exactly the "looks broken" state this whole fix
     is about avoiding. Shows a real inline message next to whichever
     form actually failed instead. */
  function showAddError(form, data) {
    var message = (data && data.message) || (data && data.description) || 'Sorry, that couldn\'t be added to your bag. Please try again.';
    var errorEl = form.querySelector('[data-mbg-cart-error]');
    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.setAttribute('data-mbg-cart-error', '');
      errorEl.className = 'mbg-cart-add-error';
      form.appendChild(errorEl);
    }
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  /* Quantity / remove — delegated, works in both the drawer and the full
     cart page since they share the same line-item markup. */
  function changeLine(line, quantity) {
    if (requestInFlight) return;
    setBusy(true);

    var body = { line: line, quantity: quantity };
    if (sectionId) body.sections = sectionId;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.sections) renderDrawer(cart.sections);
        refreshCartPage();
      })
      .catch(function () {})
      .then(function () {
        setBusy(false);
      });
  }

  document.addEventListener('click', function (evt) {
    var decrease = evt.target.closest('[data-mbg-qty-decrease]');
    var increase = evt.target.closest('[data-mbg-qty-increase]');
    var remove = evt.target.closest('[data-mbg-remove-line]');

    if (decrease || increase) {
      var stepper = (decrease || increase).closest('[data-mbg-qty-stepper]');
      var input = stepper.querySelector('[data-mbg-qty-input]');
      var next = parseInt(input.value, 10) + (increase ? 1 : -1);
      if (next < 0) return;
      input.value = next;
      changeLine(stepper.dataset.line, next);
    }

    if (remove) {
      changeLine(remove.dataset.line, 0);
    }
  });

  document.addEventListener('change', function (evt) {
    if (!evt.target.matches('[data-mbg-qty-input]')) return;
    var stepper = evt.target.closest('[data-mbg-qty-stepper]');
    var value = Math.max(0, parseInt(evt.target.value, 10) || 0);
    clearTimeout(quantityDebounce);
    quantityDebounce = setTimeout(function () {
      changeLine(stepper.dataset.line, value);
    }, 400);
  });

  /* Cart note — save on blur, no visible submit button needed. */
  document.addEventListener(
    'blur',
    function (evt) {
      if (!evt.target.matches('[data-mbg-cart-note]')) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: evt.target.value })
      }).catch(function () {});
    },
    true
  );

  /* Open the drawer from the header cart icon instead of navigating —
     reuses the theme's existing accessible Drawer class (focus trap,
     Escape-to-close, scroll lock), the same one powering search/filter. */
  var cartLink = document.querySelector('.site-header__cart');
  if (cartLink && drawer && window.theme && theme.Drawers) {
    cartLink.setAttribute('aria-controls', 'CartDrawer');
    cartLink.setAttribute('aria-expanded', 'false');
    cartLink.classList.add('js-drawer-open-cart');
    theme.CartDrawer = new theme.Drawers('CartDrawer', 'cart');
  }
})();
